import slide1 from "../assets/UMSImage/SliderImage01.png";
import slide2 from "../assets/UMSImage/slider2ndimage.png";

import dot from "../assets/UMSImage/dot.png";

import dental from "../assets/UMSImage/DentalBillingicon.png";
import internal from "../assets/UMSImage/Internal-Medicine.png";
import mentalhealth from "../assets/Specialties/mentalhealth.png";
import labbilling from "../assets/UMSImage/Lab-Billing.png";
import dermatologist from "../assets/UMSImage/Medical-Service-Dermatologist-Icons-06.png";
import podiatry from "../assets/UMSImage/Medical-Service-Icons_Podiatry.png";
import geriatrics from "../assets/UMSImage/Medical-Service-Geriatrics-Medicine-Icons-44.png";
import gynecology from "../assets/UMSImage/Medical-Service-Gynecology-Icons-10.png";

import cerdent from "../assets/UMSImage/Medical-Billing-Services_Credentialing-Services.png"
import business from "../assets/UMSImage/BusinessDevelopment.png"
import digital from "../assets/UMSImage/DigitalMarketing.png"
import health from "../assets/UMSImage/HEALTHCARECUSTOMERSERVICE.png"
import information from "../assets/UMSImage/Information-Technologies.png"
import human from "../assets/UMSImage/Human-Resource.png"
import Neurosugery from "../assets/Specialties/Medical_Service_Icons_Neurosugery.png"
import General from "../assets/Specialties/Medical_Service_Icons_General_Surgery.png"

export const SliderDetails = [
  {
    id: 1,
    title: "Get Better Care For Your",
    define: "RCM",
    description:
      "At UMS, we understand the challenges that healthcare providers face when it comes to managing their billing processes. That's why we offer a range of customizable services that are tailored to meet the unique needs of each of our clients. From coding and claim submission to denial management and appeals, we are committed to providing exceptional customer service and delivering measurable results.",
    img: slide1,
  },
  {
    id: 2,
    title: "Get Better Care For Your",
    define: "Practice",
    description:
      "UMS Billing Solution is an incorporated which specializes in Revenue Cycle Management. Experience, reliability and professionalism are important factors to consider when choosing a service provider for your medical practice. Inability to sustain high quality of service on your partner's and adversely affects your practice's operations and aggravates your patients. Realizing the importance of consistent service delivery, UMS Billing Solution works hard to maintain long term productive relationships by ensuring the highest level of satisfaction for you and your patients.",
    img: slide2,
  },
];

export const OurExpertise = [
  {
    id: "0",
    image: dental,
    title: "Dental Billing",
  },
  {
    id: "1",
    image: internal,
    title: "Internal Medicine",
  },
  {
    id: "2",
    image: Neurosugery,
    title: "Neurology",
  },
  {
    id: "3",
    image: mentalhealth,
    title: "Mental Health",
  },
  {
    id: "4",
    image: dermatologist,
    title: "Dermatologist",
  },
  {
    id: "5",
    image: podiatry,
    title: "Orthopedics",
  },
  {
    id: "6",
    image: labbilling,
    title: "Lab Billing",
  },
  {
    id: "7",
    image: General,
    title: "General Surgery",
  },
];

export const Specializes = [
  {
    id: 1,
    image: dot,
    title:
      "Streamline your healthcare practice with efficient and accurate medical billing services.",
  },
  {
    id: 2,
    image: dot,
    title:
      "Ensure compliance and accurate reimbursement with expert medical coding services.",
  },
  {
    id: 3,
    image: dot,
    title:
      "Reduce administrative burden and accelerate revenue cycle with reliable credentialing and enrollment services.",
  },
];

export const AdditionalServices = [
  {
    id: 1,
    image: cerdent,
    title: "Credentialing Services",
    description:
      "Reduce administrative burden and accelerate revenue cycle with reliable credentialing and enrollment services.",
  },
  {
    id: 2,
    image: business,
    title: "Business Development",
    description:
      "Unleash the full potential of your business with experience strategic business development solutions tailored to your unique needs, driving growth and success.",
  },
  {
    id: 3,
    image: digital,
    title: "Digital Marketing",
    description:
      "Amplify your brand, attract customers, and achieve digital marketing excellence with our tailored strategies and expertise.",
  },
  {
    id: 4,
    image: health,
    title: "Healthcare Customer Service",
    description:
      "This is a crucial role for managing appointment scheduling, patient queries, tracking overdue payments, resolving concerns and overall patient's satisfaction.",
  },
  {
    id: 5,
    image: information,
    title: "Information Technology",
    description:
      "Empower your business with cutting-edge technology and transform your operations and stay ahead of the competition with our innovative it solutions.",
  },
  {
    id: 6,
    image: human,
    title: "Human Resources",
    description:
      "Streamline HR processes and cultivate a thriving workforce with our comprehensive human resource solutions.",
  },
];
